import { apiRequest } from '../api/http'
import type {
  ChannelOrderFulfillmentRule,
  ChannelOrderFulfillmentRuleUpdateRequest,
} from './types'

const CHANNELS_BASE = '/api/channels'

export function listOrderFulfillmentRules(accessToken: string): Promise<ChannelOrderFulfillmentRule[]> {
  return apiRequest<ChannelOrderFulfillmentRule[]>(CHANNELS_BASE, '/order-fulfillment-rules', { accessToken })
}

export function saveOrderFulfillmentRule(
  accessToken: string,
  channelConnectionId: number,
  payload: ChannelOrderFulfillmentRuleUpdateRequest,
): Promise<ChannelOrderFulfillmentRule> {
  return apiRequest<ChannelOrderFulfillmentRule>(
    CHANNELS_BASE,
    `/${channelConnectionId}/order-fulfillment-rule`,
    { method: 'PUT', body: payload, accessToken },
  )
}
